import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import ContactSearchDetail from "@/components/search/ContactSearchDetail";
import type { ContactResult } from "@/lib/search-utils";
import { useTranslation } from "react-i18next";
import { PageTitleBar } from "@/components/ui/PageTitleBar";

export default function ContactDetailPage() {
  const { id = "" } = useParams();
  const { t } = useTranslation();

  const contact: ContactResult = {
    type: "contact",
    id,
    name: t("common.loading"),
    email: "",
  };

  return (
    <div className="flex h-full min-h-0 flex-col bg-background">
      <div className="relative z-20 flex h-[60px] min-h-[60px] flex-shrink-0 overflow-hidden border-b border-border bg-background">
        <PageTitleBar
          className="h-full border-0"
          rowClassName="h-full min-h-0 items-center"
          title={t("contacts.title")}
          left={
            <Button variant="ghost" size="sm" className="shrink-0 text-muted-foreground hover:text-foreground" asChild>
              <Link to="/contacts" className="inline-flex items-center gap-2">
                <ArrowLeft className="h-4 w-4" />
                <span className="hidden sm:inline">{t("common.back")}</span>
              </Link>
            </Button>
          }
        />
      </div>
      <div className="min-h-0 flex-1">
        <ContactSearchDetail contact={contact} onNavigate={() => undefined} />
      </div>
    </div>
  );
}
